module.exports = __webpack_public_path__ + "static/media/grin-alt.cb423086.svg";